/*
 * `DES-001`. What is left here is only what is genuinely this screen's own —
 * the page frame, the hint/error/section styles and the roster grid all moved
 * to `customer/CustomerPage.module.css` (shared) and `ui/Table` (the roster),
 * which is what fixed the per-row column drift.
 */
.cardTitle {
  font-family: var(--font-display);
  font-size: 1rem;
  margin: 0;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  white-space: nowrap;
}
